import(/* webpackMode: "eager", webpackExports: ["ChatGenerator"] */ "/mnt/c/shipany/ZestyGen/src/shared/blocks/chat/generator.tsx");
